import {
  TIMELINE_FINISHED_DOT_CLASS_NAME,
  TIMELINE_ACTIVE_DOT_CLASS_NAME,
  TIMELINE_PENDING_DOT_CLASS_NAME,
  TIMELINE_CLASS_NAME,
  TIMELINE_LABEL_CLASS_NAME,
  TIMELINE_CAPTION_CLASS_NAME,
} from '../../constants/timeline';

const DOT_SIZE = 28;

const dotBase = {
  margin: 0,
  padding: 0,
  boxShadow: 'none',
  width: DOT_SIZE,
  height: DOT_SIZE,
  borderRadius: '50%',
  borderWidth: 2,
  borderStyle: 'solid',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const dotSelector = (dotClass) => `& .${dotClass} .MuiTimelineDot-root, & .MuiTimelineDot-root.${dotClass}`;

// Finished and active steps share the same accent dot (finished only differs by the check
// icon, which the component adds). Reused by both classes, like confirmationIconStack in MuiStack.
const accentDot = ({ accent, accentBg }) => ({
  ...dotBase,
  backgroundColor: accentBg,
  borderColor: accent,
  color: accent,
});

const pendingDot = ({ theme }) => ({
  ...dotBase,
  backgroundColor: theme.palette.gray.A100,
  borderColor: theme.palette.gray.A400,
  color: theme.palette.gray.A400,
});

const timeline = ({ theme, accent, captionColor }) => ({
  margin: 0,
  padding: 0,
  // Left-aligned timeline: drop the opposite-content spacer MUI adds before each item.
  '& .MuiTimelineItem-root:before': {
    flex: 0,
    padding: 0,
  },
  '& .MuiTimelineConnector-root': {
    width: 2,
  },
  [`& .${TIMELINE_CAPTION_CLASS_NAME}`]: {
    color: captionColor,
  },
  // Connector below each step: accent when the step is finished, gray otherwise.
  [`& .${TIMELINE_FINISHED_DOT_CLASS_NAME} .MuiTimelineConnector-root`]: {
    backgroundColor: accent,
  },
  [`& .${TIMELINE_ACTIVE_DOT_CLASS_NAME} .MuiTimelineConnector-root, & .${TIMELINE_PENDING_DOT_CLASS_NAME} .MuiTimelineConnector-root`]: {
    backgroundColor: theme.palette.gray.A400,
  },
  [`& .${TIMELINE_FINISHED_DOT_CLASS_NAME} .${TIMELINE_LABEL_CLASS_NAME}, & .${TIMELINE_ACTIVE_DOT_CLASS_NAME} .${TIMELINE_LABEL_CLASS_NAME}`]: {
    color: theme.palette.gray.A600,
  },
  [`& .${TIMELINE_PENDING_DOT_CLASS_NAME} .${TIMELINE_LABEL_CLASS_NAME}`]: {
    color: theme.palette.gray.A400,
  },
});

export const timelineTracker = ({ theme, accent, accentBg, captionColor }) => ({
  [dotSelector(TIMELINE_FINISHED_DOT_CLASS_NAME)]: accentDot({ accent, accentBg }),
  [dotSelector(TIMELINE_ACTIVE_DOT_CLASS_NAME)]: accentDot({ accent, accentBg }),
  [dotSelector(TIMELINE_PENDING_DOT_CLASS_NAME)]: pendingDot({ theme }),
  [`&.${TIMELINE_CLASS_NAME}`]: timeline({ theme, accent, captionColor }),
});

const MuiTimeline = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...timelineTracker({
        theme,
        accent: theme.palette.primary.main,
        accentBg: theme.palette.primary.A100,
        captionColor: theme.palette.gray.A600,
      }),
    }),
  },
};

export default MuiTimeline;
